<template>
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4.69001 7.00043L0.358932 2.66935C-0.119608 2.19081 -0.119608 1.41498 0.358932 0.93719L0.936319 0.359802C1.41501 -0.118887 2.19084 -0.118887 2.66863 0.359802L6.99957 4.69073L11.3306 0.358905C11.8092 -0.119635 12.585 -0.119635 13.0628 0.358905L13.6411 0.936292C14.1196 1.41498 14.1196 2.19081 13.6411 2.66861L9.30927 7.00043L13.6402 11.3314C14.1189 11.8101 14.1189 12.5859 13.6402 13.0637L13.0628 13.6411C12.5843 14.1196 11.8084 14.1196 11.3306 13.6411L6.99957 9.30999L2.66863 13.6411C2.18994 14.1196 1.41411 14.1196 0.936319 13.6411L0.358932 13.0637C-0.119608 12.585 -0.119608 11.8092 0.358932 11.3314L4.69001 7.00043Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconCross"
}
</script>

<style scoped>

</style>